import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Row, Spinner, Form } from 'react-bootstrap'
import axios from 'axios'
import moment from "moment";
import "./Report.css"
import GridComponent from '../Table/GridComponent'
import Select from 'react-select'
import { useSelector } from 'react-redux';

function Summary() {
  const [summaryReport, setSummaryReport] = useState([])
  const [summaryFilter, setSummaryFilter] = useState({
    period: [],
    filters: {
      mediaid: "",
      affiliateid: "",
      affiliategroup: "",
      commissiongroup: ""
    }
  })
  const [dateTimeRange, setDateTimeRange] = useState({
    startDate: '',
    endDate: ''
  });
  const [isCustom, setIsCustom] = useState(false);
  const [ltComGrp, setLtComGrp] = useState([])
  const [ltAffGrp, setLtAffGrp] = useState([])
  const [affliate, setAffliate] = useState({});
  const StoreUser = useSelector((state) => state.user);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [newDepositPerm, setNewDepositPerm] = useState(false);
  const [paymentSysPerm, setPaymentSysPerm] = useState(false)
  const [CPAPerm, setCPAPerm] = useState(false)
  const [avgPlPerm, setAvgPlPerm] = useState(false)
  const [hiddenView, setHiddenViews] = useState([])
  const checkPermission = (user, permission) => {
    var Permissions = user.Permissions;
    if (Permissions && Permissions.length > 0) {
      const index = Permissions.findIndex(per => per === permission)
      if (index != -1) return true;
      else return false;
    }
    return true
  }
  const getSummaryReport = async () => {
    setSummaryLoading(true)
    const response = await axios.post(window.__CFG.API + "reports/GetSummary", summaryFilter, {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    setSummaryLoading(false)
    if (response.data.Error == null) {
      setSummaryReport(response.data.Result)
    }
    else {
      setSummaryReport([])

    }
  }
  useEffect(() => {
    setNewDepositPerm(checkPermission(affliate, "summary_total_new_deposit_amount"));
    setCPAPerm(checkPermission(affliate, "summary_cpa"));
    setAvgPlPerm(checkPermission(affliate, "summary_avg_profit_per_player"));
    setPaymentSysPerm(checkPermission(affliate, "summary_payment_system_fees"));


  }, [affliate])
  useEffect(() => {
    if (StoreUser != undefined) {
      setAffliate(StoreUser.User)
    }
  }, [affliate])
  useEffect(() => {
    var arr = []
    if (!newDepositPerm) {
      arr.push("Total New Deposit Amount")
    }

    if (!avgPlPerm) {
      arr.push("Average profit per player")
    }
    if (!CPAPerm) {
      arr.push("CPA")
    }
    if (!paymentSysPerm) {
      arr.push("Payment System Fees")
    }

    setHiddenViews(arr)
  }, [newDepositPerm, avgPlPerm, CPAPerm, paymentSysPerm])
  useEffect(() => {
    var period = []
    if (dateTimeRange.startDate != "" && dateTimeRange.endDate != "") {
      period.push(moment(dateTimeRange.startDate).startOf("day").format("YYYY-MM-DD HH:mm:ss"))
      period.push(moment(dateTimeRange.endDate).endOf("day").format("YYYY-MM-DD HH:mm:ss"))
    }
    setSummaryFilter({ ...summaryFilter, period: period })
  }, [dateTimeRange])
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleSelectPeriodChange = (e) => {
    const selectedValue = e.value;
    const today = new Date();
    let startDate = '';
    let endDate = '';
    setIsCustom(false); // Disable inputs by default

    switch (selectedValue) {
      case 'today':
        startDate = formatDate(new Date(today.setHours(0, 0, 0, 0)));
        endDate = formatDate(new Date(today.setHours(23, 59, 59, 999)));
        break;
      case 'yesterday':
        const yesterday = new Date(today.setDate(today.getDate() - 1));
        startDate = formatDate(new Date(yesterday.setHours(0, 0, 0, 0)));
        endDate = formatDate(new Date(yesterday.setHours(23, 59, 59, 999)));
        break;
      case 'currentmonth':
        startDate = formatDate(new Date(today.getFullYear(), today.getMonth(), 1));
        endDate = formatDate(today);
        break;
      case 'lastmonth':
        startDate = formatDate(new Date(today.getFullYear(), today.getMonth() - 1, 1));
        endDate = formatDate(new Date(today.getFullYear(), today.getMonth(), 0));
        break;
      case 'currentyear':
        startDate = formatDate(new Date(today.getFullYear(), 0, 1));
        endDate = formatDate(today);
        break;
      case 'lastyear':
        startDate = formatDate(new Date(today.getFullYear() - 1, 0, 1));
        endDate = formatDate(new Date(today.getFullYear() - 1, 11, 31));
        break;
      case 'custom':
        setIsCustom(true); // Enable inputs for custom range
        startDate = '';
        endDate = '';
        break;
      default:
        startDate = '';
        endDate = '';
    }
    setDateTimeRange({ startDate, endDate });

  }
  const setTodayAsDefault = () => {
    const today = new Date();
    const startDate = formatDate(new Date(today.setHours(0, 0, 0, 0)));
    const endDate = formatDate(new Date(today.setHours(23, 59, 59, 999)));
    setDateTimeRange({ startDate, endDate });
  };

  useEffect(() => {
    setTodayAsDefault();
  }, []);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDateTimeRange((prev) => ({
      ...prev,
      [name]: value
    }));
  };
  const getListAffliateGrp = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllAffiliateGroups", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtAffGrp(response.data.Result)
    }
  }
  const getListCommissionGrp = async () => {
    const response = await axios.get(window.__CFG.API + "manager/ListAllCommissionGroups", {
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("raff-token")
      }
    })
    if (response.data.Error === null) {
      setLtComGrp(response.data.Result)
    }
  }
  useEffect(() => { getListAffliateGrp(); getListCommissionGrp() }, [])
  const optionsCurrency = [{ label: "USD", value: 1 }]
  const optionsPeriods = [{ label: "Today", value: "today" }, { label: "Yesterday", value: "yesterday" }, { label: "Current month", value: "currentmonth" }, { label: "Last month", value: "lastmonth" }, { label: "Current year", value: "currentyear" }, { label: "Last year", value: "lastyear" }, { label: "Custom", value: "custom" },]
  // const selectedDateValue=optionsPeriods.find(option => option.value === affiliate.Status)
  const selectedCurrencyValue = optionsCurrency.find(option => option.value === 1)

  return (
    <Container>
      <Row>
        <Col>

          <h4 className="text-start mt-5">Report parameters</h4>

          <Row className="justify-content-between  mt-4 me-auto w-100" >
            <Col lg={6} md={4} sm={4}>
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                  <label>Period</label>
                </div>
                <div className="form-cre-grp-fl-wp-in">

                  <Select options={optionsPeriods} onChange={handleSelectPeriodChange} defaultValue={{ label: "Today", value: "today" }} />

                </div>
              </div>
            </Col>
            <Col lg={6} md={4} sm={5}>
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                  <label>Exact day</label>
                </div>
                <div className="form-cre-grp-fl-wp-in in-rp">
                  <input
                    type="date"
                    name="startDate"
                    style={{ padding: 2, marginRight: 5 }}
                    value={dateTimeRange.startDate}
                    onChange={handleInputChange}
                    disabled={!isCustom}
                  />
                </div>
                <div className="form-cre-grp-fl-wp-in in-rp">
                  <input
                    type="date"
                    name="endDate"
                    style={{ padding: 2, marginRight: 5 }}
                    value={dateTimeRange.endDate}
                    onChange={handleInputChange}
                    disabled={!isCustom}
                  />
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-between  mt-4 me-auto w-100">
            <Col lg={6} md={4} sm={4}>
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                  <label> Currency </label>
                </div>
                <div className="form-cre-grp-fl-wp-in">
                  <Select options={optionsCurrency} value={selectedCurrencyValue} />

                </div>
              </div>
            </Col>
            <Col lg={6} md={4} sm={5}>
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                  <label> Affiliate group </label>
                </div>
                <div className="form-cre-grp-fl-wp-in">
                  <Select options={ltAffGrp} onChange={e => { setSummaryFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, affiliategroup: e.value } })) }} />
                </div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-between  mt-4 me-auto w-100">
            <Col lg={6} md={4} sm={4}>
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                  <label> Commission group </label>
                </div>
                <div className="form-cre-grp-fl-wp-in">
                  <Select options={ltComGrp} onChange={e => { setSummaryFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, commissiongroup: e.value } })) }} />

                </div>
              </div>
            </Col>
            <Col lg={6} md={4} sm={5}>
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                  <label> Media id </label>
                </div>
                <div className="form-cre-grp-fl-wp-in">
                  <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type='text' value={summaryFilter.filters.mediaid} onChange={e => { setSummaryFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, mediaid: e.target.value } })) }} />
                </div>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-between  mt-4 me-auto w-100">

            <Col lg={6} md={4} sm={5}>
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                  <label> affiliate id </label>
                </div>
                <div className="form-cre-grp-fl-wp-in">
                  <Form.Control style={{ borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} type='text' value={summaryFilter.filters.affiliateid} onChange={e => { setSummaryFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, affiliateid: e.target.value } })) }} />
                </div>
              </div>
            </Col>
            <Col lg={6} md={4} sm={4} className=" pt-2 md-se-btn">
              <div className="form-cre-grp-fl-wp">
                <div className="form-cre-grp-fl-wp-lb">
                </div>
                <div className="form-cre-grp-fl-wp-in md-se-btn">
                  <Button onClick={getSummaryReport} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
                    {summaryLoading ? (<> <Spinner size="sm"></Spinner></>) : (<>
                      Generate report
                    </>)}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>

          <div style={{ borderBottom: "1px dashed black", marginTop: "30px", width: "100%" }}></div>

          <h4 className="text-start mt-2 mb-5">Summary</h4>
          <div style={{textAlign:"center"}}>
            {summaryLoading ? (<><Spinner style={{ fontSize: 14 }} /></>) : (<></>)}
          </div>
          {!summaryLoading ? (
            <GridComponent data={summaryReport} hiddenViews={hiddenView} loading={summaryLoading} />
          ) : (<></>)}

        </Col>
      </Row>
    </Container>
  )
}

export default Summary